import { useParams } from "react-router-dom";
import Header from "../components/Header";
import LectureStudentsTable from "./components/LectureStudentsTable";

const LectureStudentsPage = () => {
    const { courseId } = useParams()
    let pagesLinks = [
        {
            name: "طلاب الحصة",
            link: `/admin/lectureStudents`,
        },
        { name: "الصفحة الرئيسية", link: `/` },
        {
            name: "الفصول الدراسية",
            link: `/admin/courses`,
        },
        {
            name: "المحاضرات",
            link: `/admin/courses/${courseId}/lectures`,
        },

    ];
    return (
        <div>
            <Header
                pageName="طلاب المحاضرة"
                pages={pagesLinks}
                className="text-2xl"
            />
            <LectureStudentsTable />
        </div>
    );
}

export default LectureStudentsPage